/**
 * Resolución estable del usuario logueado para filtrar pacientes asociados
 * (`/api/personal/datos`). Misma estrategia en Historial de citas y Reportes.
 */
export const getCurrentUserId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const auth = JSON.parse(localStorage.getItem('auth_data') || 'null');
    const candidates = [
      user?.id,
      user?.user_id,
      auth?.user?.id,
      auth?.paciente?.user_id,
    ];
    const found = candidates.find(
      v => v !== undefined && v !== null && v !== '',
    );
    return found != null ? Number(found) : null;
  } catch {
    return null;
  }
};
